import React from "react";
import { useWizard } from "../../lib/wizardStore";

function Field({ id, label, hint, optional, value, onChange, type = "text", placeholder }) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-1.5">
        {label}{" "}
        {optional && <span className="text-slate-400 font-normal text-xs">(optional)</span>}
      </label>
      <input
        id={id}
        data-testid={`input-${id}`}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full rounded-xl bg-slate-50 border border-transparent py-3 px-4 text-slate-900 placeholder:text-slate-400 focus:bg-white focus:border-emerald-500 focus-ring transition-all outline-none"
      />
      {hint && <p className="text-xs text-slate-500 mt-1.5">{hint}</p>}
    </div>
  );
}

export default function BusinessInfoStep() {
  const { state, updateBusinessInfo } = useWizard();
  const b = state.businessInfo;

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          Tell us about your organization
        </h2>
        <p className="text-slate-500 mt-2">
          These details show up in your Google profile. You can edit them anytime.
        </p>
      </div>

      <div className="space-y-4">
        <Field
          id="business-name"
          label="Business name"
          placeholder="e.g. Riverside Cuts"
          value={b.name}
          onChange={(e) => updateBusinessInfo({ name: e.target.value })}
        />
        <Field
          id="phone"
          label="Phone number"
          type="tel"
          placeholder="(555) 123-4567"
          value={b.phone}
          onChange={(e) => updateBusinessInfo({ phone: e.target.value })}
        />
        <Field
          id="address"
          label="Address"
          placeholder="123 Main St, Springfield, IL"
          value={b.address}
          onChange={(e) => updateBusinessInfo({ address: e.target.value })}
        />
        <Field
          id="website"
          label="Website"
          placeholder="https://yourbusiness.com"
          optional
          value={b.website}
          onChange={(e) => updateBusinessInfo({ website: e.target.value })}
        />
        <Field
          id="service-area"
          label="Service area"
          hint="Cities or neighborhoods you serve (great for plumbers, electricians, landscapers)."
          placeholder="Springfield, Decatur, Bloomington"
          optional
          value={b.serviceArea}
          onChange={(e) => updateBusinessInfo({ serviceArea: e.target.value })}
        />
      </div>
    </div>
  );
}
